import { assignInlineVars } from "@vanilla-extract/dynamic";
import { ButtonOrLink } from "../../../design-system/primitives/components/ButtonOrLink/ButtonOrLink";
import Text from "../../../design-system/primitives/components/Text/Text";
import { textColorOn } from "../../../design-system/primitives/contrast";
import styles, { backgroundColor, textColor } from "./ModerationPlanEntry.css";
import { ArrowDownToLine } from "lucide-react";

type ModerationPlanEntryProps = {
  title: string;
  href: string;
  color: string;
};

const ModerationPlanEntry = ({
  title,
  href,
  color,
}: ModerationPlanEntryProps) => {
  const colorStyle = assignInlineVars({
    [backgroundColor]: color,
    [textColor]: textColorOn(color),
  });

  return (
    <ButtonOrLink
      className={styles.root}
      style={colorStyle}
      href={href}
      target="_blank"
      aria-label={`Moderationsplan ${title} öffnen`}
    >
      <Text variant="label" color="inherit">
        Moderationsplan
      </Text>
      <div className={styles.subheaderContainer}>
        <Text variant="subheader-small" color="inherit">
          {title}
        </Text>
        <ArrowDownToLine />
      </div>
    </ButtonOrLink>
  );
};

export default ModerationPlanEntry;
